/**
 * Route for `ironsource-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IronsourceIntegrationPage } from "../features/ironsource-integration/IronsourceIntegrationPage";

export const ironsourceIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ironsource-integration",
	component: IronsourceIntegrationPage,
});

export default ironsourceIntegrationRoute;
